import { TooltipHost } from "@fluentui/react/lib/Tooltip";
import { Text } from "@fluentui/react/lib/Text";

import { WithConfiguration } from "Components/Generic/Configuration";
import { WithTranslator } from "Components/Generic/Translator";
import { EntityType } from "Model/EntityType";
import { getFormattedValue, getTranslatedFieldLabel } from "Utils/Field";
import { IFooterElementProps } from "./IFooterElementProps";

export const FooterElement = WithTranslator(
  WithConfiguration((props: IFooterElementProps): JSX.Element => {
    const {
      fieldName, project, config, translator
    } = props;
    const fieldMeta = config.getMetadata(fieldName as string, EntityType.Project);
    const value = getFormattedValue(project, { ...fieldMeta, isRelative: false }, translator, `-`);
    const relativeValue = getFormattedValue(project, fieldMeta, translator, `-`);
    const tooltip = `${getTranslatedFieldLabel(fieldName as string, EntityType.Project, translator)}: ${value}`;
    return (
      <Text variant="smallPlus">
        <TooltipHost content={tooltip}>{relativeValue}</TooltipHost>
      </Text>
    );
  })
);
